<template>
  <div>
    <div class="form-group" :class="{'-has-error': errors.userName.length > 0}">
      <label for="user-name" class="label">Nome do Usuário</label>
      <input
        class="form-control"
        id="user-name"
        type="text"
        placeholder="Nome do Usuário"
        v-model="form.userName"
        required
      >
      <p class="description" v-if="errors.userName.length > 0">{{ errors.userName[0] }}</p>
    </div>

    <div class="form-group" :class="{'-has-error': errors.cpf.length > 0}">
      <label for="cpf" class="label">CPF</label>
      <input
        class="form-control"
        id="cpf"
        type="text"
        placeholder="CPF"
        v-mask="'###.###.###-##'"
        v-model="form.cpf"
        required
      >
      <p class="description" v-if="errors.cpf.length > 0">{{ errors.cpf[0] }}</p>
    </div>

    <div class="form-group" :class="{'-has-error' : errors.phone.length > 0}">
      <label for="phone" class="label">
        Telefone
      </label>
      <input
        class="form-control"
        id="phone"
        type="text"
        placeholder="Telefone"
        v-mask="['(##) ####-####', '(##) #####-####']"
        v-model="form.phone"
        required
      >
      <p class="description" v-if="errors.phone.length > 0">{{ errors.phone[0] }}</p>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'UserInformations',

  props: {
    errors: Object,
    form: Object,
  },

  directives: {
    mask,
  },

  mounted() {
    this.$el.querySelector('input').focus();
  },
};
</script>
